{
  "instances": {
    "loggers": {
      "label": "Журналы",
      "application": "Приложение",
      "filter": {
        "class_only": "только класс",
        "configured": "настроенные"
      },
      "instance": "Экземпляр",
      "new": "новый",
      "no_loggers_found": "Журналы не найдены.",
      "unset": "Сбросить",
      "setting_loglevel_failed": "Ошибка при установке {logger} на {loglevel}."
    }
  }
}
